<template>
  <div class="userRegister">
    <div class="back" @click="$router.go(-1)">
      <md-icon name="arrow-left"></md-icon>
      <!-- <span>忘记密码</span> -->
    </div>
    <div class="title">创建账号</div>
    <div>
      <!-- <div class="p1">
            <img src="./../../assets/img/logo.png" alt="">
            <p>欢迎来到农港城！</p>
      </div>-->
      <div class="p2">
        <div class="p2_phone">
          <input type="number" placeholder="请输入手机号" v-model="subData.mobile" maxlength="11" />
          <md-icon
            name="close"
            v-show="subData.mobile"
            @click="subData.mobile=''"
            size="sm"
          ></md-icon>
        </div>
        <div class="p2_code">
          <input type="number" placeholder="请输入验证码" v-model="subData.code" maxlength="4" />
          <button class="sendCode" :disabled="isSend" @click="sendCode">{{sendTxt}}</button>
        </div>
        <div class="p2_password">
          <input type="password" placeholder="请输入6-18位数字或英文密码" v-model="subData.password" />
        </div>
        <div class="p2_password">
          <input type="password" placeholder="请再次输入6-18位数字或英文密码" v-model="subData.password_repetition" />
        </div>
      </div>
      <div class="p4">
        <div @click="subDataFun">创建账号</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile, isPassword0 ,isCode4} from "@/utils/validate";
import { sendCode, userRegister } from "@/api/login";
import { setToken } from "@/utils/auth";
import Cookies from "@/utils/Cookies";
var t;
export default {
  name: "userRegister",
  data() {
    return {
      // 要提交的数据
      subData: {
        mobile: "",
        group:'androidPad',
        code: "",
        password: "",
        password_repetition: ""
      },

      isSend: false,
      sendTxt: "发送验证码"
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 发送验证码
    sendCode() {
      if (isMobile(this.subData.mobile)) {
        this.isSend = true;
        this.sendTxt = "发送中";
        sendCode({mobile:this.subData.mobile,usage:'register'})
          .then(res => {
            if (res.code == 200) {
              this.$toast.succeed("验证码发送成功，请注意查收");
              var time = 60;
              var that = this;
              t = setInterval(function() {
                if (time > 0) {
                  that.isSend = true;
                  that.sendTxt = time + "s";
                  time--;
                } else {
                  that.isSend = false;
                  that.sendTxt = "发送验证码";
                  clearInterval(t);
                }
              }, 1000);
            }
          })
          .catch(res => {
            this.isSend = false;
            this.sendTxt = "发送验证码";
          });
      } else {
        this.$toast.failed("请输入正确的手机号！");
      }
    },

    // 提交数据
    subDataFun() {
      if (!isMobile(this.subData.mobile)) {
        this.$toast.failed("请输入正确的手机号！");
      } else if (!isCode4(this.subData.code)) {
        this.$toast.failed("请输入正确的验证码！");
      } else if (!isPassword0(this.subData.password)) {
        this.$toast.failed("请输入6-18位数字或英文密码！");
      } else if (!isPassword0(this.subData.password_repetition)) {
        this.$toast.failed("请再次输入6-18位数字或英文密码！");
      } else if (this.subData.password + "" != this.subData.password_repetition + "") {
        this.$toast.failed("两次输入的密码不一致！");
      } else {
        userRegister(this.subData).then(res => {
          if (res.code == 200) {
            clearInterval(t);
            this.$toast.loading("账号注册成功！正在登录...");
            this.isSend = false;
            this.sendTxt = "发送验证码";
            var data = {
              username: this.subData.mobile,
              password: this.subData.password,
              group: this.subData.group,
            }
            setToken(res.data.access_token);
            Cookies.set("userInfo",JSON.stringify(res.data.user))
            Cookies.set("shopInfo", JSON.stringify(res.data.shop));
            setTimeout(()=>{
              this.$toast.succeed("登录成功");
              this.$router.push("/");
            },1000)
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.userRegister {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 0.7rem;
  font-size: 0.24rem;
  text-align: left;
  position: relative;
  .back {
    font-size: 0.38rem;
    position: absolute;
    top: 0;
    left: 0.3rem;
    z-index: 60;
    // width: 0.8rem;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.24rem;
      font-weight: bold;
    }
  }
  .title{
    width: 100%;
    padding: 0 0.2rem;
    text-align: left;
    font-size: 0.28rem;
    line-height: 0.88rem;
  }
  .p1 {
    width: 100%;
    text-align: left;
    img {
      width: 1.34rem;
      height: 1.35rem;
      padding-bottom: 0.1rem;
      margin-bottom: 0.2rem;
    }
    p {
      font-size: 0.28rem;
      color: #999;
    }
  }
  .p2 {
    width: 4.63rem;
    margin: 0 auto;
    margin-top: 0.2rem;
    position: relative;
    font-size: 0.24rem;
    & > div {
      padding-top: 0.48rem;
      border-bottom: 0.01rem solid #cccccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &>input {
        width: 4.63rem;
        background-color: transparent;
        outline: none;
        border: none;
        font-size: 0.24rem;
        line-height: 0.4rem;
        color: #404040;
        &::placeholder {
          color: #cccccc;
        }
      }
      &:nth-child(2) {
        input {
          width: 3.8rem;
        }
      }
    }
    .sendCode {
      width: 1.8rem;
      text-align: right;
      border: none;
      background-color: transparent;
      font-size: 0.24rem;
      color: #31b158;
      &[disabled] {
        color: #999;
      }
    }
  }

  .p3 {
    margin: 0.3rem auto 0;
    display: flex;
    justify-content: space-between;
    color: #999999;
    .forget {
      color: #999999;
    }
  }
  .p4 {
    padding-top: 0.5rem;
    width: 4.63rem;
    margin: 0 auto;
    div {
      width: 4.63rem;
      box-sizing: border-box;
      height: 0.66rem;
      border-radius: 0.33rem;
      font-size: 0.28rem;
      line-height: 0.66rem;
      text-align: center;
      color: #999;
      font-weight: 500;
      margin-top: 0.4rem;
      border: 0.01rem solid #ccc;
      &:nth-child(1) {
        // background-color: #31b158;
        background:linear-gradient(-90deg,#25A94D,#3FBE66);
        box-shadow: 0 0.05rem 0.06rem 0 rgba(49,177,88,0.15);
        border: none;
        color: #fff;
      }
    }
  }
}
</style>